module.exports = __webpack_public_path__ + "img/94.19ec7068.jpg";